import { cn } from "@/projects/lib/utils";
import type { SubmissionStatus } from "@/projects/lib/store";

const map: Record<
  SubmissionStatus,
  { label: string; cls: string; dot: string }
> = {
  Pending: {
    label: "Pending",
    cls: "bg-saffron-soft text-saffron border-saffron/30",
    dot: "bg-saffron",
  },
  "Assigned for Verification": {
    label: "Assigned",
    cls: "bg-royal-soft text-royal border-royal/30",
    dot: "bg-royal",
  },
  "Not Proper": {
    label: "Not Proper",
    cls: "bg-destructive/10 text-destructive border-destructive/30",
    dot: "bg-destructive",
  },
  "Not Eligible": {
    label: "Not Eligible",
    cls: "bg-destructive/10 text-destructive border-destructive/30",
    dot: "bg-destructive",
  },
  "Ready for Reward": {
    label: "Ready for Reward",
    cls: "bg-success/10 text-success border-success/30",
    dot: "bg-success",
  },
};

export function StatusBadge({
  status,
  className,
}: {
  status: SubmissionStatus;
  className?: string;
}) {
  const s = map[status];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium",
        s.cls,
        className
      )}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full", s.dot)} />
      {s.label}
    </span>
  );
}
